import { defineMessage } from 'react-intl';

export const headingI18n = {
  about: defineMessage({
    id: 'heading.about',
    defaultMessage: 'About'
  }),
  classes: defineMessage({
    id: 'heading.classes',
    defaultMessage: 'Classes'
  }),
  login: defineMessage({
    id: 'heading.log-in',
    defaultMessage: 'Log in'
  }),
  popularTopics: defineMessage({
    id: 'heading.popular-topics',
    defaultMessage: 'Popular topics'
  }),
  reviews: defineMessage({
    id: 'heading.reviews',
    defaultMessage: 'Reviews'
  })
};
